import EstablishmentApi from '../api/establishment/EstablishmentApi';
import LoginApi from '../api/authentication/loginApi';
import { is301Required } from '../components/common/Utility';

export function generateSubmissionReport() {
  const today = new Date().toLocaleDateString('en-US');
  const year = new Date().toLocaleDateString('en-US', { year: 'numeric' });
  let establishmentsData = [];
  let loginData = {};

  function fetchEstablishments() {
    return EstablishmentApi.getAllEstablishments()
      .then(response => {
        if (response.success) {
          establishmentsData = response.results.filter(establishment => establishment.establishment_status !== 2);
        }
      });
  }

  function getUser() {
    return LoginApi.realLoginWithLoginGov()
      .then(response => {
        if (response.success) {
          loginData = response;
        }
      });
  }

  function submissionStatus(submissionStatus) {
    switch (submissionStatus) {
      case 1: return 'Not Submitted';
      case 2: return 'Submitted';
      case 3: return 'Submitted';
      default: return 'Unknown Status';
    }
  }

  function submittedStates(establishment) {
    if (establishment.submission_status === 1 && (establishment.combined_submission_status === 0 || typeof establishment.combined_submission_status == 'undefined')) {
      return 'Pending 300A';
    } else if ((establishment.submission_status === 3 || establishment.submission_status === 2) && (establishment.combined_submission_status === 0 || typeof establishment.combined_submission_status == 'undefined')) {
      return `${establishment.total_submitted_cases} cases out of ${establishment.expected_cases_count} added`;
    } else if ((establishment.submission_status === 3 || establishment.submission_status ===  2) && establishment.combined_submission_status === 1) {
      return `${establishment.total_submitted_cases} cases out of ${establishment.expected_cases_count} submitted`;
    }
  }

  function Return301ColumnData(establishment) {
    return is301Required(establishment)
      .then(requirementStatus => {
        if (requirementStatus === 1) {
          return "Not required to file 300/301";
        } else if (requirementStatus === 2) {
          return submittedStates(establishment);
        } else {
          return "Please check your state plan";
        }
      });
  }

  function tableRows() {
    // Create an array of promises for each row
    const rowPromises = establishmentsData.sort((a, b) => b.last_edited_timestamp - a.last_edited_timestamp).map(establishment => {
      return Return301ColumnData(establishment).then(return301Data => `
        <tr>
          <td>${establishment.establishment_name}</td>
          <td>${establishment.address.street}</td>
          <td>${establishment.address.city}</td>
          <td>${establishment.address.state}</td>
          <td>${establishment.address.zip}</td>
          <td>${submissionStatus(establishment.submission_status)}</td>
          <td>${return301Data}</td>
          <td>${establishment.last_edited_timestamp !== 0 ? new Date(establishment.last_edited_timestamp).toLocaleDateString('en-US') : new Date(establishment.created_timestamp).toLocaleDateString('en-US')}</td>
        </tr>
      `);
    });

    // Wait for all row promises to resolve and join them into a single string
    return Promise.all(rowPromises).then(rows => rows.join(''));
  }

  function renderHTML(rows) {
    const newWindow = window.open('', '_blank');

    newWindow.document.write(`
    <!DOCTYPE html>
    <html lang="en">

    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Submission Report</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: center;
            }

            .container {
                max-width: 1000px;
            }

            h1,
            h2,
            h3,
            h4 {
                font-weight: lighter;
            }

            h1 {
                font-size: 2rem;
                margin: 0;
                color: rgba(158, 34, 34, 1);
            }

            h2 {
                font-size: 1.5rem;
                margin: 0;
                color: rgba(158, 34, 34, 1);
            }

            h3 {
                font-size: .8rem;
                margin-top: .2rem;
            }

            h4 {
                font-size: .65rem;
                color: #aaa
            }

            img {
                width: 200px;
            }

            ul {
                margin: 0;
            }

            li {
                margin-top: .3rem;
            }

            p {
                margin: 0;
            }

            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 2rem;
                table-layout: fixed;
                word-wrap: break-word;
            }

            th {
                background-color: #dfe1e2;
                text-align: left;
            }

            th,
            td {
                padding: .75rem;
                text-align: left;
                font-size: .9rem;
                white-space: normal;
                overflow-wrap: break-word;
            }

            tr {
                border-bottom: 1px solid #dfe1e2;
            }

            tr:hover {
                background-color: rgba(223, 225, 226, .4);
            }

            .row {
                width: 100%;
                display: flex;
            }

            .justify-between {
                display: flex;
                justify-content: space-between;
            }

            .items-center {
                display: flex;
                align-items: center;
            }

            .flex-column {
                display: flex;
                flex-direction: column;
            }

            .mt-2 {
                margin-top: 2rem;
            }

            .note {
                background-color: #fff4f4;
                border-left: 4px solid #d83933;
                padding: 1rem;
                font-weight: bold;
            }

            .note-header {
                font-size: 1.2rem;
                margin: .5rem 0rem;
            }

            .h-min {
                height: min-content;
            }

            .px-5 {
                padding-left: 5rem;
                padding-right: 5rem;
            }

            .py-1 {
                padding-top: 1rem;
                padding-bottom: 1rem;
            }

            .ml-8 {
                margin-left: 8rem;
            }

            .print-btn {
                background-color: #005ea2;
                color: white;
                border: none;
                border-radius: 4px;
            }

            .print-btn:hover {
                cursor: pointer;
            }
        </style>
    </head>

    <body>
        <div class="container">
            <div class="row justify-between items-center">
                <img src="/sites/default/files/ita-logo-borderless-trimmed.png" alt="ita-logo" />
                <h4>Printed ${today} by [${loginData.firstName} ${loginData.lastName}][${loginData.email}][${loginData.userId}]</h4>
            </div>
            <div class="row mt-2 items-center justify-between">
                <h1>Injury Tracking Application (ITA)<br/>Submission Summary</h1>
                <button onclick="openPrintWindow()" class="h-min px-5 py-1 ml-8 print-btn">Print</button>
                <script>
                  function openPrintWindow() {
                    window.print();
                  }
                </script>
            </div>
            <div>
                <h3>This summary is provided to verify the user’s ITA submission and the status of each establishment in the user’s ITA profile.</h3>
            </div>
            <div class="row mt-2 flex-column">
                <h2>ITA Submission Summary - ${year}:</h2>
                <ul>
                    <li>Total number of establishments in user profile: ${establishmentsData.length}</li>
                    <li>Establishments with 300A submitted as of ${today}: ${establishmentsData.filter(establishment => establishment.submission_status === 3 || establishment.submission_status === 2).length}</li>
                    <li>Establishments with 300/301 submitted as of ${today}: ${establishmentsData.filter(establishment => establishment.combined_submission_status === 1).length}</li>
                </ul>
            </div>
            <table>
                <tr>
                    <th>Name</th>
                    <th>Street</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Zip Code</th>
                    <th>300A Status</th>
                    <th>300/301 Status</th>
                    <th>Last Update</th>
                </tr>
                ${rows}
            </table>
            <div class="row mt-2">
                <p><b>Note:</b> Some users may have duplicate establishment profiles for the same establishment in the ITA. Additionally, not all establishments are required to submit both 300A and 300/301 data. Visit <a href="www.osha.gov/injuryreporting">www.osha.gov/injuryreporting</a>                to learn more about ITA submission requirements, and how to add, edit, or remove establishments</p>
            </div>
            <div class="row mt-2 flex-column note">
                <p class="note-header">Reminders and Resources</p>
                <ul>
                    <li>The deadline for timely submission of injury and illness data is between January 2 and March 2 of each year.</li>
                    <li>You can make updates and edits to your submission in the ITA as needed.</li>
                    <li>Visit <a href="www.osha.gov/injuryreporting">www.osha.gov/injuryreporting</a> for additional information about the ITA.</li>
                    <li>Visit <a href="www.osha.gov/recordkeeping">www.osha.gov/recordkeeping</a> for additional information on recordkeeping requirements.</li>
                </ul>
            </div>
        </div>
    </body>

    </html>
    `);
    newWindow.document.close();
  }

  // Ensure fetchEstablishments and getUser complete, and tableRows is resolved before rendering HTML
  Promise.all([fetchEstablishments(), getUser()])
    .then(() => {
      return tableRows();
    })
    .then(rows => {
      renderHTML(rows);
    });
}



/** WEBPACK FOOTER **
 ** ./src/actions/generateSubmissionReport.js
 **/